// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__7+rwo","item":"Tabs_item__v9GNL","selected":"Tabs_selected__kXvYv","large":"Tabs_large__8pdJ7","small":"Tabs_small__cXUfl"};